
document.addEventListener("DOMContentLoaded", function () {
  
  $('.lob_lob_slider').ready(function () {
    $('.lob_lob_slider').on('init', function(event, slick) {
      const $initLobSlider = slick.$slider[0];

      // Timeout needed for slow loading
      setTimeout(() => {
        customSlickSlider();
        setInitialSlideVisibility($initLobSlider);
      }, 500);
    });
    $('.lob_lob_slider').slick({
      slidesToShow: 7,
      slidesToScroll: 4,
      infinite: false,
      prevArrow: $('.lobstripe-left-arrow'),
      nextArrow: $('.lobstripe-right-arrow'),
      variableWidth: true,
      speed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 3,
            infinite: false,
            variableWidth: true,
            speed: 1000,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
            infinite: false,
            variableWidth: true,
            speed: 1000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            variableWidth: true,
            speed: 500,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            variableWidth: true,
            speed: 500,
          },
        },
      ],
    });
    $('.lobstripe-left-arrow').hide();
    $('.lob_lob_slider').on('afterChange', function (event, slick, currentSlide) {
      const $lobSlider = slick.$slider[0];
      setSlideVisibility($lobSlider);
      if (currentSlide === 0) {
        $('.lobstripe-left-arrow').hide();
      } else {
        $('.lobstripe-left-arrow').show();
      }
    });

    // Remove aria-describedby from slick slides
    $('.lob_lob_slider').each(function () {
      var lob_sliderId_1 = $(this);
      const slickSlides = $(lob_sliderId_1).find('.slick-list .slick-slide');
      if (slickSlides) {
        setTimeout(() => {
          adaFormatSlickSlides(slickSlides);
        }, 250);
      }
    });
  });

  $('.app_lob_slider').ready(function () {
    $('.app_lob_slider').on('init', function(event, slick) {
      const $initAppLobSlider = slick.$slider[0];

      // Timeout needed for slow loading
      setTimeout(() => {
        customSlickSlider();
        setInitialSlideVisibility($initAppLobSlider);
      }, 500);
    });
    $('.app_lob_slider').slick({
      slidesToShow: 4,
      slidesToScroll: 3,
      infinite: false,
      prevArrow: $('.appstripe-left-arrow'),
      nextArrow: $('.appstripe-right-arrow'),
      variableWidth: true,
      speed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            infinite: false,
            variableWidth: true,
            speed: 1000,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: true,
            speed: 1000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            variableWidth: true,
            speed: 500,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            variableWidth: true,
            speed: 500,
          },
        },
      ],
    });
    $('.appstripe-left-arrow').hide();
    $('.app_lob_slider').on('afterChange', function (event, slick, currentSlide) {
      const $appLobSlider = slick.$slider[0];
      setSlideVisibility($appLobSlider);
      if (currentSlide === 0) {
        $('.appstripe-left-arrow').hide();
      } else {
        $('.appstripe-left-arrow').show();
      }
    });

    // Remove aria-describedby from slick slides
    $('.app_lob_slider').each(function () {
      var app_lob_sliderId_1 = $(this);
      const slickSlides = $(app_lob_sliderId_1).find('.slick-list .slick-slide');
      if (slickSlides) {
        setTimeout(() => {
          adaFormatSlickSlides(slickSlides);
        }, 250);
      }
    });
  });
})
